const fbConfig = {
    apiKey: "AIzaSyAJMOoZDw6aGvPJ-gHG6QiP_AuwE8Rd2N4",
    authDomain: "msap-429e1.firebaseapp.com",
    projectId: "msap-429e1",
    storageBucket: "msap-429e1.appspot.com",
    messagingSenderId: "142763930260",
    appId: "1:142763930260:web:1967af5f0575db70f0ba81",
    measurementId: "G-B6J0RBQJKV",
    databaseURL: "https://msap-429e1-default-rtdb.europe-west1.firebasedatabase.app/"
  };

// react-redux-firebase config
const rrfConfig = {
  userProfile: 'users'
  // useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
  // enableClaims: true // Get custom claims along with the profile
}

export {fbConfig, rrfConfig}